import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/hocs/TranslationsProvider/TranslationsProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingPageTemplate"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/templates/LandingPageTemplate/LandingPageTemplate.tsx");
